import { joinUrl } from '@root/src/lib/joinUrl';
function checkForErrors(response) {
    if (!response.ok) {
        throw Error(response.statusText ||
            `getUser | An api call returned HTTP status ${response.status}`);
    }
    return response;
}
const callApi = (url) => {
    return fetch(url, {
        credentials: 'include',
    })
        .then(checkForErrors)
        .then((response) => response.json());
};
export const getUser = async (ajaxUrl) => {
    const url = joinUrl([ajaxUrl, 'profile/me']);
    return callApi(url)
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'get-user');
    })
        .then((json) => json.userProfile)
        .catch((error) => {
        window.guardian.modules.sentry.reportError(error, 'get-user');
    });
};
